var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",class:_vm.getClassName(),on:{"click":_vm.click}},[_c('use',{ref:"svgIcon",attrs:{"xlink:href":"","xmlns:xlink":"http://www.w3.org/1999/xlink"}})])}
var staticRenderFns = []

export { render, staticRenderFns }